export const geoApiOptions = {
    method: "GET",
    headers: {
      "X-RapidAPI-Key": 'fa7b1b09e2msh986fe6d37013e5bp18e2f5jsnac522aca9d55',
      "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
    },
  };
  export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";
  
  export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
  export const WEATHER_API_KEY = "15b87354a34729b48359d0024b060fe4"; 